{
  "pt": {
    "button": {
      "actions": {
        "add": "Adicionar",
        "cancel": "Cancelar",
        "close": "Fechar",
        "copyEmail": "Copiar e-mail",
        "create": "Criar",
        "delete": "Eliminar",
        "display": "Mostrar",
        "edit": "Editar",
        "hide": "Esconder",
        "loading": "A carregar",
        "more": "Mais ações",
        "move": "Mover",
        "move_down": "Mover para baixo",
        "move_up": "Mover para cima",
        "no": "Não",
        "reactivateEmailAddress": "Reativar o endereço de e-mail",
        "reset": "Reiniciar",
        "save": "Guardar",
        "save_changes": "Guardar alterações",
        "save_message": "Guardar mensagem",
        "saving": "A guardar",
        "share": "Partilhar",
        "startTour": "Iniciar visita guiada",
        "uploadingDocuments": "A carregar documentos",
        "yes": "Sim"
      }
    }
  }
}
